import { render, staticRenderFns } from "./MsgAfterBought.vue?vue&type=template&id=1568fffe&scoped=true&"
import script from "./MsgAfterBought.vue?vue&type=script&lang=js&"
export * from "./MsgAfterBought.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1568fffe",
  null
  
)

export default component.exports